export default __webpack_public_path__ + "static/media/wildlife06.ea39a451.png";